export interface FlagsType {
  mweb: {
    load_wallet: boolean,
    redeem_wallet: boolean,
    view_transaction: boolean,
    multimodal_payment: boolean,
  }
}

/**
 * @description
 * Flags like viewTransaction to decide whether to display view transaction link.
 */
export const flagsTransformer = (flags:FlagsType) => {
  if (!flags || !flags.mweb) {
    return {};
  }
  return {
    loadWallet: flags.mweb.load_wallet,
    redeemWallet: flags.mweb.redeem_wallet,
    viewTransaction: flags.mweb.view_transaction,
    multiModalPayment: flags.mweb.multimodal_payment,
  };
};
